import { createSelector } from 'reselect';
import { RootState } from 'src/app/store';
import { LoadingState } from './loadingStore';

const getState = (state: RootState): LoadingState => state.loading;

export const getIsLoading = createSelector(getState, state => state.isLoading);

export const getChangeDutyStatusSuccess = createSelector(getState, state => state.changeDutyStatus);
